require('./mortgageRequestDataPropiertorErrorView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

const WizardError = require('components/commons/wizardError/wizardError');


class MortgageRequestErrorView extends React.Component {
    constructor(props) {
        super(props);
        this.buildTexts = this.buildTexts.bind(this);
    }
    buildTexts() {
        let titleKey = "mortgageRequestPresentation-title_errorTitleGeneric";
        let textElement = (
            <div className="hire-card-neruda-error__text">
                <FormattedText value="mortgageRequestPresentation-text_errorTextGeneric" />
            </div>
        );
        return {
            textElement,
            titleKey
        };
    }

    render() {

        const { textElement, titleKey } = this.buildTexts();
        const goBackButton = {
            label: (
                <FormattedText
                    format="uppercase"
                    value="mortgageRequestPresentation-backButtonLabel"
                />
            ),
            url: '/myprofile/loans-mortgages'
        };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
            >
                <article className="hire-card-neruda-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

MortgageRequestErrorView.propTypes = {
    immLoans: PropTypes.object,
    location: PropTypes.object
};

module.exports.constructor = MortgageRequestErrorView;

module.exports.MortgageRequestErrorView = connect(
    state => ({
        immLoans: state.loans
    }),
    {}
)(MortgageRequestErrorView);
